import { NgModule, Component } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { LoginComponent } from './login/login.component';
import { LoginWithoutCaptchaComponent } from './loginWithoutCaptcha/login-without-captcha.component';
import { authInterceptorProviders } from './services/http-auth-interceptor.service';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { AuthGuard } from './gaurds/auth.guard';

// Blank component for MSAL popup redirect (prevents router errors in popup window)
@Component({ template: '', standalone: true })
class MsalRedirectBlankComponent {}

const routes: Routes = [
  { path: 'login', component: LoginComponent},
  { path: 'loginWithoutCaptcha', component: LoginWithoutCaptchaComponent },
  { path: '', component: LoginComponent, canActivate: [AuthGuard] },
  // { path: '', redirectTo: '/organization', pathMatch: 'full' },

  // { path: 'edi/ediUser', loadChildren: () => import('./ediComponents/edi/edi.module').then(m => m.EdiModule) },
  {
    path: '',
    component: LayoutComponent,
    children: [

      {
        path: '',
        loadChildren: () => import('./storeConfiguratorComponents/store-configurator.module').then(m => m.StoreConfiguratorModule)
      },
      {
        path: 'edi',
        loadChildren: () => import('./ediComponents/edi.module').then(m => m.EdiModule)
      },
      {
        path: 'shippingService',
        loadChildren: () => import('./shippingServiceComponents/shipping-service.module').then(m => m.ShippingServiceModule)
      },
      {
        path: 'configPortal',
        loadChildren: () => import('./configPortalComponents/config-portal.module').then(m => m.ConfigPortalModule)
      },
    ]
  },
  // Handles MSAL popup hash routes like "code=..." / "error=..." that Angular can't match
  {
    matcher: (segments: UrlSegment[]) => {
      const first = segments?.[0]?.path ?? '';
      return segments.length === 1 && (
        first.startsWith('code') ||
        first.startsWith('error') ||
        first.startsWith('code%3D') ||
        first.startsWith('error%3D')
      )
        ? { consumed: segments }
        : null;
    },
    component: MsalRedirectBlankComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }, authInterceptorProviders],
})
export class AppRoutingModule { }
